/*
 * Страница DefectDojo кластера (Component defectdojo-<кластер>): обзор и ссылки (интерфейс,
 * ArgoCD, values в gitops), кластеры, которые шлют сюда отчёты, приложение ArgoCD, алерты и поды
 * namespace defectdojo. Находки конкретного сервиса — на его вкладке Security.
 */
import { Grid } from '@material-ui/core';
import { InfoCard } from '@backstage/core-components';
import {
  EntityAboutCard,
  EntityLayout,
  EntityLinksCard,
  EntitySwitch,
} from '@backstage/plugin-catalog';
import { useEntity } from '@backstage/plugin-catalog-react';
import {
  EntityKubernetesContent,
  isKubernetesAvailable,
} from '@backstage/plugin-kubernetes';
import {
  EntityArgoCDOverviewCard,
  isArgocdAvailable,
} from '@roadiehq/backstage-plugin-argo-cd';
import { Progress, ResponseErrorPanel } from '@backstage/core-components';
import { DefectDojoSenders, useDefectDojoSenders } from './DefectDojoCells';

const SendersCard = () => {
  const { entity } = useEntity();
  const state = useDefectDojoSenders(entity);
  return (
    <InfoCard
      title="Отчёты кластеров"
      subheader="Пайплайны сервисов этих кластеров шлют сюда отчёты проверок безопасности (app:defectdojo)"
    >
      {state.loading && <Progress />}
      {state.error && <ResponseErrorPanel error={state.error} />}
      {state.value && <DefectDojoSenders clusters={state.value} />}
    </InfoCard>
  );
};

export const defectdojoEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6} xs={12}>
          <EntityAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityLinksCard />
        </Grid>
        <Grid item md={12} xs={12}>
          <SendersCard />
        </Grid>
        <EntitySwitch>
          <EntitySwitch.Case if={e => Boolean(isArgocdAvailable(e))}>
            <Grid item md={12} xs={12}>
              <EntityArgoCDOverviewCard />
            </Grid>
          </EntitySwitch.Case>
        </EntitySwitch>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route
      path="/kubernetes"
      title="Kubernetes"
      if={isKubernetesAvailable}
    >
      <EntityKubernetesContent />
    </EntityLayout.Route>
  </EntityLayout>
);
